
import { analytics, type EventName, type AnalyticsEventMap, type UserIdentityData, type ProfileIdentityData } from '@/services/analyticsService';

export type TrackingEventName = EventName;

export const trackEvent = <K extends EventName>(eventName: K, params?: AnalyticsEventMap[K]) => {
  analytics.track(eventName, params);
};

export const trackUserIdentity = (user: UserIdentityData, profileData?: ProfileIdentityData) => {
  analytics.identify(user, profileData);
};

export { analytics };

